import React from 'react'

const ChiefComplaint = (props) => {
    let { widgetsPreviewData: Data } = props;
    // let noValExistTextNA = <p className="text ar-light-color">N/A</p>;
    let noValExistText = <p className="text ar-light-color">No data recorded</p>;
  return (
        <div className="d-flex gap-10">
          <div className="ar-form-counter flex-center">
            <p className='text text-black'>{props?.itemCount}</p>
          </div>
          <div className="d-flex flex-column gap-6 w-100">
            <p className='heading fs-13'>Chief Complaint</p>
            <div>
              {Data?.ChiefComplaint ?
                <p className="text">{Data?.ChiefComplaint}</p> : noValExistText}
            </div>
          </div>
        </div>
  )
}

export default ChiefComplaint